<template>
    <div id="galleriFilter">        
        <GalleriFilterItem 
            :label="$texts.program"
            filterType="program"
            :filterTypeLabel="$texts.program"
            :filterItems="programFilter"
            subFilterType="arskurs"
            :subFilterTypeLabel="$texts.arskurs"
            :subFilterItems="arskursFilter"
            :currentTags="currentTags"
        >
        </GalleriFilterItem>
        <GalleriFilterItem 
            :label="$texts.projekt"
            filterType="projekttyp"
            :filterTypeLabel="$texts.projekt"
            :filterItems="projekttypFilter"
        >
        </GalleriFilterItem>
        <GalleriFilterItem 
            :label="$texts.ar"
            filterType="ar"
            :filterTypeLabel="$texts.ar"
            :filterItems="arFilter"
        >
        </GalleriFilterItem>

        <GalleriFilterItem v-if="anpassadeAlternativLabel"
            :label="anpassadeAlternativLabel"
            filterType="anpassatAlternativ"
            :filterTypeLabel="anpassadeAlternativLabel"
            :filterItems="anpassadeAlternativFilter"
        >
        </GalleriFilterItem>
    </div>
</template>

<script>
import GalleriFilterItem from "./galleriFilterItem.vue";

export default {
    name: "GalleriFilter",
    props: {
        programFilter: Object,
        arskursFilter: Object,
        projekttypFilter: Object,
        anpassadeAlternativFilter: Object,
        anpassadeAlternativLabel: String,
        arFilter: Object,
        urlSearchParams: Object,
        currentTags: Array
    },
    components: {
        GalleriFilterItem
    },
    methods: {
        updateUrl(paraObj) {
            const usp = new URLSearchParams(window.location.search);

            const name = paraObj.name;
            const tag = paraObj.tag;
            const urlVals = paraObj.urlVals;
            const tagsToDelete = paraObj.subTagsToDelete;

            usp.set(name, urlVals);

            if (paraObj.add) {
                this.$parent.currentTags.push(tag);
            } else {
                this.$parent.currentTags = this.$parent.currentTags.filter(val => val !== tag);
                if (!_.isEmpty(tagsToDelete.tags)) {
                    tagsToDelete.tags.forEach(subVal => {
                        usp.delete(tagsToDelete.type);
                        this.$parent.currentTags = this.$parent.currentTags.filter(val => val !== subVal);
                    });
                }

                if (_.isEmpty(urlVals)) {
                    usp.delete(name);
                }
            }
            
            usp.set("page", 1);
            history.replaceState(null, null, "?" + usp.toString());
        }
    }
}
</script>
